<form [formGroup]="form" class="h-full flex items-center">
  <mat-form-field class="basis-full" subscriptSizing="dynamic">
    <mat-icon [ngClass]="iconClass" class="w-[40px] scale-90" matPrefix>search</mat-icon>
    <input
      id="filter-input"
      matInput
      formControlName="search"
      autocomplete="off"
      [placeholder]="placeholder | transloco"
      [ngClass]="inputClass"
    />
  </mat-form-field>
</form>
